const config = {
    baseURL: "https://dawny-prod-zv9au.ondigitalocean.app/v1",
};

export default config;
